<template>
    <div>
        <div class="content-nav__wrapper">
            <div class="title-wrapper">
                <span style="color: #999999;">配音类型</span>
                <button :class="{'active': typeCode===0}" @click="getTaskList(0, statusCode, 1)"><span>{{ $t('word.all') }}</span></button>
                <button :class="{'active': typeCode===1}" @click="getTaskList(1, statusCode, 1)"><span>小说书籍</span></button>
                <button :class="{'active': typeCode===2}" @click="getTaskList(2, statusCode, 1)"><span>专栏文章</span></button>
                <button :class="{'active': typeCode===3}" @click="getTaskList(3, statusCode, 1)"><span>亲子儿童</span></button>
            </div>
            <div class="title-wrapper">
                <span style="color: #999999;">任务状态</span>
                <button :class="{'active': statusCode===0}" @click="getTaskList(typeCode, 0, 1)"><span>{{ $t('word.all') }}</span></button>
                <button :class="{'active': statusCode===1}" @click="getTaskList(typeCode, 1, 1)"><span>{{ $t('word.inProduction') }}</span></button>
                <button :class="{'active': statusCode===2}" @click="getTaskList(typeCode, 2, 1)"><span>{{ $t('word.acceptance') }}</span></button>
                <button :class="{'active': statusCode===4}" @click="getTaskList(typeCode, 4, 1)"><span>{{ $t('comb.acceptanceRejection') }}</span></button>
                <button :class="{'active': statusCode===3}" @click="getTaskList(typeCode, 3, 1)"><span>{{ $t('word.finished') }}</span></button>
            </div>
        </div>
        <div class="copyright-empty-task-list" v-if="totalCount === 0 && statusCode===0" >
            <p class="no-task">您可以通过<a :href="`${$store.state.A_PC_HOST}/requirementview`">参加海选</a>获得更多播讲机会</p>
        </div>
        <div class="copyright-tasks-list__wrapper" v-else v-loading.body="pageLoading">
            <div class="copyright-tasks-list__title-wrapper">
              <span class="copyright-tasks-list__work-info">作品信息</span>
              <span class="copyright-task-list__type">类型</span>
              <span class="copyright-task-list__deliver-date">更新/交付</span>
              <span class="copyright-task-list__status-code">状态</span>
              <span class="copyright-task-list__operation">操作</span>
            </div>
            <div v-for="(item,index) in taskList" class="copyright-tasks-list-item-wrapper">
              <div class="copyright-tasks-list__work-info">
                <img v-if="item.coverPath" class="copyright-tasks-list__book-cover" :src="$store.state.UPLOAD_IMG_HOST+item.coverPath" @error="setDefaultBookCoverImg(index)" ref="img">
                <img v-else class="copyright-tasks-list__book-cover" :src="$store.state.IMG_HOST+'bookCoverDefault.png'">
                <span style="padding: 15px;word-break: break-all;">{{ item.requirementName }}</span>
              </div>
              <span class="copyright-task-list__type">
                {{ item.dubbingTypeStr }}
              </span>
              <span class="copyright-task-list__deliver-date">
                {{ item.deliveryTimeStr || item.deliveryFrequencyStr }}
              </span>
              <div class="copyright-task-list__status-code">
                <span>{{ getStatusLabel(item.taskStatusId) }}</span>
                <span v-if="item.exchangeEvent && item.exchangeEvent.status === 1" class="vacation-label">请假审核中</span>
                <span v-if="item.exchangeEvent && item.exchangeEvent.status === 2 && isEarlierThanNow(item.exchangeEvent.startTime)" class="vacation-label">请假中</span>
              </div>
              <div class="copyright-task-list__operation copyright-task-list-item-buttons">
                  <a v-if="item.dubbingType === 'book'" :href="`${$store.state.A_PC_HOST}/requirement/${item.requirementId}/candidate`" class="check-task" target="_blank">{{ $t('word.check') }}</a>
                  <a v-else :href="`${$store.state.A_PC_HOST}/dub/anchors/requirements/${item.requirementId}`" class="check-task" target="_blank">{{ $t('word.check') }}</a>
                  <a v-if="item.exchangeEvent && (item.exchangeEvent.status === 1 || (item.exchangeEvent.status === 2 && !isEarlierThanNow(item.exchangeEvent.endTime)))" @click="showVacationInfo(item.exchangeEvent)" class="check-task-vacation-btn">
                      {{ $t('word.check') }}{{ $t('word.vacate') }}
                  </a>
                  <el-dialog :close-on-click-modal="false" :title="`${$t('word.check')}${$t('word.vacate')}`" v-model="isShowVacationInfo" size="tiny">
                      <div slot="" class="pop-vacation-info">
                          <p><span>{{ $t('word.suspendTime') }}：</span><span>{{ $t('word.from') }}
                              {{ formatDate(vacationInfo.startTime) }} {{ $t('word.to') }} {{ formatDate(vacationInfo.endTime) }}
                              {{ $t('word.total') }}{{ getDuration(vacationInfo.startTime, vacationInfo.endTime) }}
                              {{ $t('word.day') }}</span></p>
                          <p><span>{{ $t('comb.additionalRemarks') }}：</span><span>{{ vacationInfo.description }}</span></p>
                          <p><span>{{ $t('comb.commitTime') }}：</span><span>{{ formatDate(vacationInfo.createTime) }}</span></p>
                          <p><span>{{ $t('word.status') }}：</span><span v-if="vacationInfo.status===1">{{ $t('word.toBeAudit') }}</span><span v-if="vacationInfo.status===2">{{ $t('word.passAudit') }}</span></p>
                          <div class="buttons">
                              <el-button type="primary" size="small" @click="isShowVacationInfo=false;">{{ $t('word.close') }}</el-button>
                              <el-button size="small" @click="cancelVacation">{{ $t('word.cancel') }}{{ $t('word.vacate') }}</el-button>
                          </div>
                      </div>
                      <div slot="footer" style="display: none;"></div>
                  </el-dialog>
              </div>
            </div>
        </div>
        <div class="center-tasks-pagination">
            <span>{{ $t('word.total') }} {{ totalCount }} {{ $t('word.item') }}</span>
            <el-pagination :current-page="pageIndex" @current-change="pageChange" :page-count="totalPage" layout="prev, pager, next"></el-pagination>
        </div>
    </div>
</template>
<script>
  import axios from 'axios';
  import moment from 'moment';
  export default {
    components: {
      axios
    },
    data() {
      return {
        vacationInfo: {},
        isShowVacationInfo: false,
        pageLoading: true,
        statusCode: 0,
        typeCode: 0,
        taskList:[],
        pageIndex: 0,
        totalPage: 0,
        totalCount: 0
      }
    },
    beforeMount() {
      this.getTaskList(0, 0, 1);
    },
    methods: {
      getTaskList (typeCode, statusCode, pageIndex) {
        this.statusCode = statusCode;
        this.typeCode = typeCode;
        this.pageLoading = true;
        const that = this;
        this.pageIndex = pageIndex;
        that.taskList = null;
        axios.get(`/api/anchor/requirement/accepted/status/${statusCode}/page/${this.pageIndex}/type/${this.typeCode}`,{
        }).then(res => {
          if (res.data.code === 200) {
            that.taskList = res.data.data.items;
            that.totalPage = res.data.data.pages;
            that.totalCount = res.data.data.total;
          }
          that.pageLoading = false;
        });
      },
      setDefaultBookCoverImg (index) {
        this.$refs.img[index].src = this.$store.state.DEFAULT_BOOK_COVER;
      },
      pageChange (curPage) {
        this.getTaskList(this.typeCode, this.statusCode, curPage);
      },
      isEarlierThanNow (startDate) {
        return startDate < new Date();
      },
      showVacationInfo (vacationInfo) {
        this.vacationInfo = vacationInfo;
        this.isShowVacationInfo = true;
      },
      cancelVacation () {
        this.$confirm('确定要取消请假申请？', '取消请假', {

          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          axios.post('/event/vacation/cancel/' + this.vacationInfo.id).then(res => {
            if(res.data.code === 200) {
              location.reload();
            } else {
              this.$notify({
                type: 'warning',
                message: '撤销请假失败，' + res.data.message
              })
            }
          });
        });
      },
      formatDate(date) {
        return moment(date).format('YYYY-MM-DD');
      },
      getDuration(startDate, endDate) {
        return moment(endDate).diff(moment(startDate), 'days')+1;
      },
      getStatusLabel(statusCode) {
        var statusName = ['已接受', '制作中', '验收中', '已完结', '验收未通过'];
        return statusName[statusCode];
      }
    },
    computed: {
      IMG_HOST() {
        return this.$store.state.IMG_HOST;
      }

    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/anchor/task-list.scss";
    @import "../../../sass/icons.scss";
</style>



// WEBPACK FOOTER //
// MyAudioBook.vue?bb5bda76